import { useTranslation } from 'react-i18next';
import { BoldLabelFormItem } from 'components/form/BoldLabelFormItem';
import { Row, Col, Input, Select } from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
// import TextArea from 'antd/es/input/TextArea';
// import { Spinner } from 'components';
import React, { useEffect, /*useImperativeHandle, */ useState } from 'react';
import { AgreementCard } from './Agreement/AgreementCard';
// import Visibility from 'assets/images/eye-open.svg';
// import VisibilityOff from 'assets/images/eye-off.svg';
// import { formatCardNumber2 } from 'utils/formate/cardNumber';
// import { useNavigate } from 'react-router-dom';
// import styled from 'styled-components';
interface commonListProps {
  label: string;
  labelTc: string;
  value: string;
  code: string;
}

export interface ChangePolicyOptionsCardRef {
  getOriginValue: () => string;
  getOriginValue2: () => string;
}

export const ChangePolicyOptionsCard = React.forwardRef<
  ChangePolicyOptionsCardRef,
  {
    myBankList: { label: string; value: string; chineseDescription: string; description: string }[];
    errorMessage: string;
    dividendOptionsList: commonListProps[];
    paymentOptionsList: commonListProps[];
    paymentMethodList: commonListProps[];
    chequeList: commonListProps[];
    companyCode: string;
    Message: string;
    annPaymentMethodList: commonListProps[];
    payPMName: string;
    divPMName: string;
    diviName: string;
    payName: string;
  }
>((props /*,ref*/) => {
  const { t, i18n } = useTranslation();
  const form = useFormInstance();
  // const [showCardMask, setShowCardMask] = useState<boolean>(true);
  // const [showCardMask2, setShowCardMask2] = useState<boolean>(true);
  const [formState, setFormState] = useState({
    divdendMethod: form.getFieldValue('dividendOptionsCashPaymentMethod') ?? '',
    dividendOptions: form.getFieldValue('dividendOptions') ?? '',
    paymentMethod: form.getFieldValue('paymentOptionsCashPaymentMethod') ?? '',
    paymentOptions: form.getFieldValue('paymentOptions') ?? '',
    dividendOptionsCashPaymentMethodCheque:
      props.chequeList.length === 1
        ? props.chequeList[0].value
        : form.getFieldValue('dividendOptionsCashPaymentMethodCheque') ?? '',
    paymentOptionsCashPaymentMethodCheque:
      props.chequeList.length === 1
        ? props.chequeList[0].value
        : form.getFieldValue('paymentOptionsCashPaymentMethodCheque') ?? '',
    dividendOptionsCode: form.getFieldValue('dividendOptionsCode') ?? '', //綁定code
    paymentOptionsCode: form.getFieldValue('paymentOptionsCode') ?? '',
    divdendMethodCode: form.getFieldValue('dividendOptionsCashPaymentMethodCode') ?? '',
    paymentMethodCode: form.getFieldValue('paymentOptionsCashPaymentMethodCode') ?? '',
  });
  // const [originValue, setOriginValue] = useState<string>(
  //   form.getFieldValue('dividendOptionsCashPaymentMethodAccountNo'),
  // );
  // const [originValue2, setOriginValue2] = useState<string>(
  //   form.getFieldValue('paymentOptionsCashPaymentMethodAccountNo'),
  // );
  // const [paymentModeList, setPaymentModeList] = useState<
  //   {
  //     label: string;
  //     labelTc:string;
  //     value: string;
  //   }[]
  // >([]); // 修改为数组类型
  // const [paymentMethodList, setPaymentMethodList] = useState<
  //   {
  //     label: string;
  //     value: string;
  //     code: string;
  //   }[]
  // >([]); //methodList
  // const [newPaymentMethodList, setNewPaymentMethodList] = useState<
  //   {
  //     label: string;
  //     value: string;
  //     code: string;
  //   }[]
  // >([]); //xuanrandemethodList
  // const {
  //   data: ArrangeInformation,
  //   shouldFetch: ContactInformationShouldFetch,
  //   error: ArrangeInfoError,
  // } = usePaymentArrangement(key, token || '', props.policyNumber, props.companyCode);
  // useEffect(() => {
  //   setKey(generateKey());
  //   if (props.policyNumber) {
  //     shouldFetchPaymentMethod(true);
  //     ContactInformationShouldFetch(true);
  //   }
  // }, [ContactInformationShouldFetch, props.policyNumber, shouldFetchPaymentMethod]);
  // useEffect(() => {
  //   if (ArrangeInformation && !ArrangeInfoError) {
  //     const list = ArrangeInformation.premiumFrequencyData?.map((item) => {
  //       return {
  //         label: isEnglish ? item.description : item.descriptionTc,
  //         value: item.description,
  //         codeList: item.paymentMethodData,
  //         idcode: item.premiumFrequencyCode,
  //       };
  //     });
  //     setPaymentModeList(list);
  //     // 使用list而不是paymentModeList来避免异步问题
  //     const selectedItem = list.find((item) => item.idcode == ArrangeInformation.paymentMode);
  //     if (selectedItem) {
  //       const codelist = selectedItem.codeList;
  //       const filteredList = paymentMethodList.filter((item) => codelist.includes(item.code));
  //       setNewPaymentMethodList(filteredList);
  //     }
  //     console.log('ArrangeInformation', ArrangeInformation);
  //   }
  // }, [ArrangeInfoError, ArrangeInformation, paymentMethodList, isEnglish]);
  // useEffect(() => {
  //   shouldFetchIdType(true);
  // }, [shouldFetchIdType]);
  // useEffect(() => {
  //   setIncomePaymentMethod(form.getFieldValue('paymentMethoddf'));
  //   // shouldFetchPaymentMode(true);
  // }, [setIncomePaymentMethod, form]);
  // useEffect(() => {
  //   shouldFetchBankList(true);
  // }, [shouldFetchBankList]);
  // const myBankList: { label: string; value: string }[] = [];
  // bankList?.banks?.map((item: { bankCode: string; bankName: string; bankNameTc: string }) => {
  //   myBankList.push({
  //     label: `${item.bankCode}-${isEnglish ? item.bankName : item.bankNameTc}`,
  //     value: item.bankCode,
  //   });
  // });

  // const idTypeList: { label: string; value: string }[] = [];
  // idType?.map((item: { idTypeDesc: string; idTypeDescTc: string; idType: string }) => {
  //   idTypeList.push({
  //     label: isEnglish ? item.idTypeDesc : item.idTypeDescTc,
  //     value: item.idType,
  //   });
  // });
  // useEffect(() => {
  //   if (paymentMethod) {
  //     const list = paymentMethod.map((item) => {
  //       return {
  //         label: isEnglish ? item.description : item.descriptionTc,
  //         value: item.description,
  //         code: item.paymentMethodCode,
  //       };
  //     });
  //     setPaymentMethodList(list);
  //   }
  // }, [paymentMethod, isEnglish]);
  useEffect(() => {
    if (props.chequeList.length === 1) {
      form.setFieldsValue({
        dividendOptionsCashPaymentMethodCheque: props.chequeList[0].value,
      });
      form.setFieldsValue({
        paymentOptionsCashPaymentMethodCheque: props.chequeList[0].value,
      });
    }
    // eslint-disable-next-line
  }, [props.chequeList]);
  const paymentBankCode = (e: string) => {
    console.log(e);
  };
  const dividendBankCode = (e: string) => {
    console.log(e);
  };
  const dividendMethodChange = (e: string) => {
    const code = props.paymentMethodList.find((i) => i.value == e)?.code;
    setFormState({ ...formState, divdendMethod: e, divdendMethodCode: code });
    form.setFieldsValue({
      dividendOptionsCashPaymentMethodCode: code,
    });
  };
  const paymentMethodChange = (e: string) => {
    const code = props.annPaymentMethodList.find((i) => i.value == e)?.code;
    setFormState({ ...formState, paymentMethod: e, paymentMethodCode: code });
    form.setFieldsValue({
      paymentOptionsCashPaymentMethodCode: code,
    });
  };
  const dividendCashChequeChange = (e: string) => {
    setFormState({ ...formState, dividendOptionsCashPaymentMethodCheque: e });
    //
    // form.setFieldsValue({
    //   dividendOptionsCashPaymentMethodCheque: e,
    // });
  };
  const paymentCashChequeChange = (e: string) => {
    setFormState({ ...formState, paymentOptionsCashPaymentMethodCheque: e });
    //
    // form.setFieldsValue({
    //   paymentOptionsCashPaymentMethodCheque: e,
    // });
  };
  const DividendOptionsChange = (e: string) => {
    const label = props.dividendOptionsList.find((i) => i.code == e)?.label;
    setFormState({ ...formState, dividendOptionsCode: e, dividendOptions: label });
    form.setFieldsValue({
      dividendOptions: label,
    });
    // const selectedItem = props.dividendOptionsList.find((item) => item.value == e);
    // form.setFieldsValue({
    //   dividendOptions: e,
    // });
    // form.setFieldsValue({
    //   dividendOptionsEn: selectedItem?.value,
    // });
    // if (selectedItem) {
    //   const codelist = selectedItem;
    //   const filteredList = paymentMethodList.filter((item) => codelist.includes(item.code));
    //   console.log('filteredList', filteredList);
    //   setNewPaymentMethodList(filteredList);
    // }
    // console.log('eeeee', e);
  };
  const IncomePaymentMethodchange = (e: string) => {
    const label = props.paymentOptionsList.find((i) => i.code == e)?.label;
    setFormState({ ...formState, paymentOptionsCode: e, paymentOptions: label });

    // setshowcard('');
    // const list = props.paymentOptionsList.find((item) => item.value == e);
    form.setFieldsValue({
      paymentOptions: label,
    });
    // form.setFieldsValue({
    //   IncomePaymentMethod: list[0]?.label,
    // });
    // form.setFieldsValue({
    //   IncomePaymentMethoden: list[0]?.value,
    // });
    // setIncomePaymentMethod(e);
  };
  // const CashPaymentMethodchange = (e: string) => {
  //   console.log('090909', e);
  //   setshowcard('');
  //   const list = newPaymentMethodList.filter((item) => item.code == e);
  //   form.setFieldsValue({
  //     CashPaymentMethoddf: e,
  //   });
  //   form.setFieldsValue({
  //     CashPaymentMethod: list[0]?.label,
  //   });
  //   form.setFieldsValue({
  //     CashPaymentMethoden: list[0]?.value,
  //   });
  //   console.log('000000000', form.getFieldValue('CashPaymentMethod'));
  //   setCashPaymentMethod(e);
  // };
  // const changeEye = () => {
  //   if (showCardMask && form.getFieldValue('dividendOptionsCashPaymentMethodAccountNo')) {
  //     form.setFieldsValue({
  //       dividendOptionsCashPaymentMethodAccountNo: formatCardNumber2(originValue),
  //     });
  //   } else {
  //     form.setFieldsValue({
  //       dividendOptionsCashPaymentMethodAccountNo: originValue,
  //     });
  //   }
  //   if (showCardMask2 && form.getFieldValue('paymentOptionsCashPaymentMethodAccountNo')) {
  //     form.setFieldsValue({
  //       paymentOptionsCashPaymentMethodAccountNo: formatCardNumber2(originValue2),
  //     });
  //   } else {
  //     form.setFieldsValue({
  //       paymentOptionsCashPaymentMethodAccountNo: originValue2,
  //     });
  //   }
  // };
  const branchNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // if (e.target.value != form.getFieldValue('dividendOptionsCashPaymentMethodBankCodeOld')) {
    //   setshowcard('D');
    // } else {
    //   setshowcard('');
    // }
    const value = e.target.value.replace(/[^0-9*X]/g, '');
    // setOriginValue(value);

    return value;
  };
  const branchNumberChange2 = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/[^0-9*X]/g, '');
    // setOriginValue2(value);

    return value;
  };
  // const bankNoBlur = () => {
  //   changeEye();
  // };
  // const changeCardMask = (e: React.MouseEvent) => {
  //   e.stopPropagation();
  //   setShowCardMask(!showCardMask);
  // };
  // const changeCardMask2 = (e: React.MouseEvent) => {
  //   e.stopPropagation();
  //   setShowCardMask2(!showCardMask2);
  // };
  //mask eyes display
  // useEffect(() => {
  //   if (originValue) changeEye();
  //   if (originValue2) changeEye();
  //   // if (idValue) IdCardBlur();
  //   // if (cardOriValue) creditNoBlur();
  //   // eslint-disable-next-line
  // }, [showCardMask, showCardMask2]);
  // useImperativeHandle(ref, () => ({
  //   getOriginValue: () => {
  //     return originValue; // 返回子组件的值
  //   },
  //   getOriginValue2: () => {
  //     return originValue2; // 返回子组件的值
  //   },
  // }));
  // const formatDate = (value) => {
  //   if (!value) return value;
  //   const valueArr = value.replace(/\D/g, '').split('');
  //   if (valueArr.length <= 2) {
  //     return valueArr.join('').replace(/(\d{2})(\d{0,2})/, '$1/$2');
  //   }
  //   return valueArr.slice(0, 2).join('') + '/' + valueArr.slice(2, 6).join('');
  // };
  // setshowcard(e);
  // useEffect(() => {
  //   setshowcard(form.getFieldValue('paymentMethoddf'));
  //   // shouldFetchPaymentMode(true);
  // }, [setshowcard, form]);
  return (
    <Row>
      <Row
        justify="center"
        gutter={[16, { xs: 8, sm: 8, lg: 24 }]}
        style={{ rowGap: 0 }}
        className="ChangePaymentContactCard"
      >
        {props.dividendOptionsList.length > 0 && (
          <div>
            <Col xs={24} md={24}>
              <BoldLabelFormItem
                style={{
                  borderBottom: '1px solid #CCC',
                  marginBottom: formState.dividendOptionsCode !== 'CASHPAYS' ? '0' : '24px',
                }}
                rules={[{ required: true, message: t('common.error.requiredField') }]}
                required
                label={
                  <div
                    className="CreditCardNumber"
                    style={{
                      color: '#6f7072',
                      fontWeight: 'normal',
                      fontSize: '17px',
                      fontFamily: 'Roboto400',
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div>{t('life.policyOptions.dividendOptions')}</div>
                    {/* <div>
                  {ArrangeInformation?.paymentModeDisable && (
                    <Popover placement="leftBottom" content={`${t('life.policyOptions.Alert')}`}>
                      <img src={tanhao} style={{ margin: '0  2px 0 10px', width: '20px', height: '20px' }} />
                    </Popover>
                  )}
                </div> */}
                  </div>
                }
                name="dividendOptionsCode"
              >
                {/* {' '} */}
                <Select
                  onChange={DividendOptionsChange}
                  popupClassName="slectop2"
                  placeholder={t('life.policyOptions.dividendOptions')}
                  disabled={props.dividendOptionsList.length === 1}
                  defaultValue={props.diviName}
                  style={{
                    fontSize: '20px',
                    fontFamily: 'Roboto400',
                    fontWeight: 'normal',
                    marginBottom: '24px',
                    padding: '4px 0',
                  }}
                >
                  {props.dividendOptionsList &&
                    props.dividendOptionsList.map((item) => (
                      <Select.Option key={item.label} value={item.code}>
                        {i18n.language == 'en' ? item.label : item.labelTc}
                      </Select.Option>
                    ))}
                </Select>
              </BoldLabelFormItem>
            </Col>
            {formState.dividendOptionsCode == 'CASHPAYS' && (
              <Col xs={24} md={24} style={{ borderBottom: '1px solid #CCC' }}>
                <BoldLabelFormItem
                  rules={[{ required: true, message: t('common.error.requiredField') }]}
                  required
                  label={
                    <div
                      className="CreditCardNumber"
                      style={{
                        color: '#6f7072',
                        fontWeight: 'normal',
                        fontSize: '17px',
                        fontFamily: 'Roboto400',
                        display: 'flex',
                        justifyContent: 'space-between',
                        paddingLeft: '20px',
                      }}
                    >
                      <div>{t('life.policyOptions.dividendOptionsCashPaymentMethod')}</div>
                    </div>
                  }
                  name="dividendOptionsCashPaymentMethod"
                  className="error-align"
                >
                  {/* {' '} */}
                  <Select
                    onChange={dividendMethodChange}
                    popupClassName="slectop2"
                    placeholder={t('life.policyOptions.dividendOptionsCashPaymentMethod')}
                    // disabled={ArrangeInformation?.paymentModeDisable}
                    defaultValue={props.divPMName}
                    style={{
                      fontSize: '20px',
                      fontFamily: 'Roboto400',
                      fontWeight: 'normal',
                      // marginBottom: '15px',
                      padding: '4px 0',
                      paddingLeft: '20px',
                    }}
                  >
                    {props.paymentMethodList &&
                      props.paymentMethodList.map((item) => (
                        <Select.Option key={item.label} value={item.value}>
                          {i18n.language == 'en' ? item.label : item.labelTc}
                        </Select.Option>
                      ))}
                  </Select>
                </BoldLabelFormItem>
                {formState.divdendMethodCode == 'DC' && formState.dividendOptionsCode == 'CASHPAYS' && (
                  <div
                    style={{
                      fontSize: '17px',
                      fontFamily: 'Roboto400',
                      color: '#6f7072',
                      width: '100%',
                      paddingLeft: '20px',
                      marginBottom: '24px',
                    }}
                  >
                    <div>
                      <span>{t('life.policyOptions.HKDdesscription')}</span>
                    </div>
                  </div>
                )}
              </Col>
            )}
            {formState.divdendMethodCode == 'CQ' && formState.dividendOptionsCode == 'CASHPAYS' && (
              <Col xs={24} md={24} style={{ borderBottom: '1px solid #CCC', paddingTop: '24px' }}>
                <BoldLabelFormItem
                  // style={{ borderBottom: '1px solid #CCC' }}
                  rules={[{ required: true, message: t('common.error.requiredField') }]}
                  required
                  label={
                    <div
                      className="CreditCardNumber"
                      style={{
                        color: '#6f7072',
                        fontWeight: 'normal',
                        fontSize: '17px',
                        fontFamily: 'Roboto400',
                        display: 'flex',
                        justifyContent: 'space-between',
                        paddingLeft: '20px',
                      }}
                    >
                      <div>{t('life.policyOptions.dividendOptionsCashPaymentMethodCheque')}</div>
                    </div>
                  }
                  className="error-align"
                  name="dividendOptionsCashPaymentMethodCheque"
                >
                  {/* {' '} */}
                  <Select
                    onChange={dividendCashChequeChange}
                    popupClassName="slectop2"
                    placeholder={t('life.policyOptions.dividendOptionsCashPaymentMethodCheque')}
                    // disabled={ArrangeInformation?.paymentModeDisable}
                    style={{
                      fontSize: '20px',
                      fontFamily: 'Roboto400',
                      fontWeight: 'normal',
                      // marginBottom: '15px',
                      padding: '4px 0',
                      paddingLeft: '20px',
                    }}
                    disabled={props.chequeList.length == 1}
                  >
                    {props.chequeList &&
                      props.chequeList.map((item) => (
                        <Select.Option key={item.label} value={item.value}>
                          {i18n.language == 'en' ? item.label : item.labelTc}
                        </Select.Option>
                      ))}
                  </Select>
                </BoldLabelFormItem>

                {formState.dividendOptionsCashPaymentMethodCheque === 'HKD' &&
                  !(props.chequeList.length == 1 && props.chequeList[0].value.toLowerCase() == 'hkd') && (
                    <div
                      style={{
                        fontSize: '17px',
                        fontFamily: 'Roboto400',
                        color: '#6f7072',
                        width: '100%',
                        marginBottom: '24px',
                        paddingLeft: '20px',
                      }}
                    >
                      <div>
                        <span>{t('life.policyOptions.HKDdesscription')}</span>
                      </div>
                    </div>
                  )}
              </Col>
            )}
            {formState.divdendMethodCode == 'DC' && formState.dividendOptionsCode == 'CASHPAYS' && (
              <Row
                justify="center"
                gutter={[16, { xs: 8, sm: 8, lg: 24 }]}
                style={{ rowGap: 0 }}
                className="ChangePaymentContactCard"
              >
                <Col
                  xs={24}
                  md={24}
                  style={{ borderBottom: '1px solid #CCC', marginBottom: '24px', paddingTop: '24px' }}
                >
                  <BoldLabelFormItem
                    rules={[{ required: true, message: t('common.error.requiredField') }]}
                    required
                    label={
                      <span
                        style={{
                          color: '#6f7072',
                          fontWeight: 'normal',
                          fontSize: '17px',
                          fontFamily: 'Roboto400',
                          paddingLeft: '20px',
                        }}
                      >
                        {t('life.policyOptions.dividendOptionsCashPaymentMethodBankCode')}
                      </span>
                    }
                    className="error-align"
                    name="dividendOptionsCashPaymentMethodBankCode"
                  >
                    {/* {' '} */}
                    <Select
                      onChange={dividendBankCode}
                      popupClassName="slectop2"
                      placeholder={t('life.MakeRequest.payment.BankCodeholder')}
                      style={{
                        fontSize: '20px',
                        fontFamily: 'Roboto400',
                        fontWeight: 'normal',
                        paddingLeft: '20px',
                      }}
                      showSearch
                      filterOption={(input, bank) => (bank?.key ?? '').toLowerCase().includes(input.toLowerCase())}
                    >
                      {props.myBankList &&
                        props.myBankList.map((item) => (
                          <Select.Option key={item.label} value={item.value}>
                            {item.label}
                          </Select.Option>
                        ))}
                    </Select>
                  </BoldLabelFormItem>
                </Col>

                <Col xs={24} md={24} style={{ borderBottom: '1px solid #CCC', marginBottom: '24px' }}>
                  <BoldLabelFormItem
                    required
                    rules={[
                      { required: true, message: t('common.error.requiredField') },
                      { pattern: /^\d{3}$/, message: t('life.MakeRequest.payment.InvalidBranchNumber') },
                    ]}
                    label={
                      <span
                        style={{
                          color: '#6f7072',
                          fontWeight: 'normal',
                          fontSize: '17px',
                          fontFamily: 'Roboto400',
                          paddingLeft: '20px',
                        }}
                      >
                        {t('life.MakeRequest.payment.BranchNumber')}
                      </span>
                    }
                    className="error-align"
                    name="dividendOptionsCashPaymentMethodBranchNo"
                  >
                    <Input
                      size="middle"
                      placeholder={t('life.MakeRequest.payment.BranchNumber')}
                      style={{
                        // color: "white",
                        // backgroundColor: 'transparent',
                        fontSize: '20px',
                        fontFamily: 'Roboto400',
                        padding: '0 10px',
                        marginLeft: '20px',
                        width: 'calc(100% - 20px)', // 通过计算宽度来减少20px
                      }}
                    />
                  </BoldLabelFormItem>
                </Col>
                <Col xs={24} md={24} style={{ borderBottom: '1px solid #CCC', marginBottom: '24px' }}>
                  <BoldLabelFormItem
                    rules={[
                      { required: true, message: t('common.error.requiredField') },
                      {
                        // /^\d{1,9}$/
                        pattern: /^\d{1,9}$/,
                        message: t('life.MakeRequest.payment.InvalidBankAccountNumber'),
                      },
                    ]}
                    required
                    label={
                      <span
                        style={{
                          color: '#6f7072',
                          fontWeight: 'normal',
                          fontSize: '17px',
                          fontFamily: 'Roboto400',
                          paddingLeft: '20px',
                        }}
                      >
                        {t('life.MakeRequest.payment.BankAccountNumber')}
                      </span>
                    }
                    className="error-align"
                    name="dividendOptionsCashPaymentMethodAccountNo"
                  >
                    <Input
                      size="middle"
                      onChange={branchNumberChange}
                      placeholder={t('life.MakeRequest.payment.BankAccountNumber')}
                      style={{
                        // color: "white",
                        // backgroundColor: 'transparent',
                        fontSize: '20px',
                        fontFamily: 'Roboto400',
                        padding: '4px 10px',
                        marginLeft: '20px',
                        width: 'calc(100% - 20px)', // 通过计算宽度来减少20px
                      }}
                      // onBlur={bankNoBlur}
                      // onFocus={() => {
                      //   form.setFieldValue('dividendOptionsCashPaymentMethodAccountNo', originValue);
                      // }}
                      // suffix={
                      //   showCardMask ? (
                      //     <img src={Visibility} onClick={(e) => changeCardMask(e)} />
                      //   ) : (
                      //     <img src={VisibilityOff} onClick={(e) => changeCardMask(e)} />
                      //   )
                      // }
                    />
                  </BoldLabelFormItem>
                  {formState.divdendMethodCode == 'DC' && formState.dividendOptionsCode == 'CASHPAYS' && (
                    <div
                      style={{
                        fontSize: '17px',
                        fontFamily: 'Roboto400',
                        color: '#C21B17',
                        width: '100%',
                        marginBottom: '24px',
                        paddingLeft: '20px',
                      }}
                    >
                      <div>
                        <span>{t('life.policyOptions.provideProof')}</span>
                      </div>
                    </div>
                  )}
                </Col>
                {/* <Col xs={24} md={24} style={{ borderBottom: '1px solid #CCC', marginBottom: '10px' }}>
                <div
                  style={{
                    fontSize: '17px',
                    fontFamily: 'Roboto400',
                    color: '#6F7072',
                    width: '100%',
                    marginBottom: '25px',
                  }}
                >
                  <div>
                    <span>{t('life.MakeRequest.payment.policyholderAccount')}</span>
                  </div>
                </div>
              </Col> */}
                <Col xs={24} md={24}>
                  <BoldLabelFormItem
                    rules={[{ required: true, message: t('common.error.requiredField') }]}
                    required
                    label={
                      <span
                        style={{
                          color: '#6f7072',
                          fontWeight: 'normal',
                          fontSize: '17px',
                          fontFamily: 'Roboto400',
                          paddingLeft: '20px',
                        }}
                      >
                        {t('life.MakeRequest.payment.AccountHolderName')}
                      </span>
                    }
                    className="error-align"
                    name="dividendOptionsCashPaymentMethodHolderName"
                  >
                    <Input
                      size="middle"
                      placeholder={t('life.MakeRequest.payment.AccountHolderName')}
                      style={{
                        // color: "white",
                        // backgroundColor: 'transparent',
                        fontSize: '20px',
                        fontFamily: 'Roboto400',
                        padding: '4px 10px',
                        marginLeft: '20px',
                        width: 'calc(100% - 20px)', // 通过计算宽度来减少20px
                      }}
                    />
                  </BoldLabelFormItem>
                </Col>
              </Row>
            )}
          </div>
        )}
        {props.paymentOptionsList.length > 0 && (
          <div
            style={{
              marginTop: props.dividendOptionsList.length > 0 && formState.divdendMethodCode !== 'DC' ? '24px' : '0',
            }}
          >
            <Col xs={24} md={24}>
              <BoldLabelFormItem
                style={{
                  borderBottom: '1px solid #CCC',
                  marginBottom: formState.paymentOptionsCode !== 'CASHPAYS' ? '0' : '24px',
                }}
                rules={[{ required: true, message: t('common.error.requiredField') }]}
                required
                label={
                  <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto400' }}>
                    {t('life.policyOptions.paymentOptions')}
                  </span>
                }
                name="paymentOptionsCode"
              >
                {/* {' '} */}
                <Select
                  popupClassName="slectop2"
                  placeholder={t('life.policyOptions.paymentOptions')}
                  disabled={props.paymentOptionsList.length === 1}
                  defaultValue={props.payName}
                  onChange={IncomePaymentMethodchange}
                  style={{
                    fontSize: '20px',
                    fontFamily: 'Roboto400',
                    fontWeight: 'normal',
                    marginBottom: '24px',
                    padding: '4px 0',
                  }}
                >
                  {props.paymentOptionsList &&
                    props.paymentOptionsList.map((item) => (
                      <Select.Option key={item.label} value={item.code}>
                        {i18n.language == 'en' ? item.label : item.labelTc}
                      </Select.Option>
                    ))}
                </Select>
              </BoldLabelFormItem>
            </Col>
            {formState.paymentOptionsCode == 'CASHPAYS' && (
              <Col xs={24} md={24} style={{ borderBottom: '1px solid #CCC' }}>
                <BoldLabelFormItem
                  rules={[{ required: true, message: t('common.error.requiredField') }]}
                  required
                  label={
                    <div
                      className="CreditCardNumber"
                      style={{
                        color: '#6f7072',
                        fontWeight: 'normal',
                        fontSize: '17px',
                        fontFamily: 'Roboto400',
                        display: 'flex',
                        justifyContent: 'space-between',
                        paddingLeft: '20px',
                      }}
                    >
                      <div>{t('life.policyOptions.paymentOptionsCashPaymentMethod')}</div>
                    </div>
                  }
                  className="error-align"
                  name="paymentOptionsCashPaymentMethod"
                >
                  {/* {' '} */}
                  <Select
                    onChange={paymentMethodChange}
                    popupClassName="slectop2"
                    placeholder={t('life.policyOptions.paymentOptionsCashPaymentMethod')}
                    // disabled={ArrangeInformation?.paymentModeDisable}
                    defaultValue={props.payPMName}
                    style={{
                      fontSize: '20px',
                      fontFamily: 'Roboto400',
                      fontWeight: 'normal',
                      // marginBottom: '15px',
                      padding: '4px 0',
                      paddingLeft: '20px',
                    }}
                  >
                    {props.annPaymentMethodList &&
                      props.annPaymentMethodList.map((item) => (
                        <Select.Option key={item.label} value={item.value}>
                          {i18n.language == 'en' ? item.label : item.labelTc}
                        </Select.Option>
                      ))}
                  </Select>
                </BoldLabelFormItem>
                {formState.paymentMethodCode == 'DC' && formState.paymentOptionsCode == 'CASHPAYS' && (
                  <div
                    style={{
                      fontSize: '17px',
                      fontFamily: 'Roboto400',
                      color: '#6f7072',
                      width: '100%',
                      marginBottom: '24px',
                      paddingLeft: '20px',
                    }}
                  >
                    <div>
                      <span>{t('life.policyOptions.HKDdesscription')}</span>
                    </div>
                  </div>
                )}
              </Col>
            )}
            {formState.paymentMethodCode == 'CQ' && formState.paymentOptionsCode == 'CASHPAYS' && (
              <Col xs={24} md={24} style={{ borderBottom: '1px solid #CCC', paddingTop: '24px' }}>
                <BoldLabelFormItem
                  // style={{ borderBottom: '1px solid #CCC' }}
                  rules={[{ required: true, message: t('common.error.requiredField') }]}
                  required
                  label={
                    <div
                      className="CreditCardNumber"
                      style={{
                        color: '#6f7072',
                        fontWeight: 'normal',
                        fontSize: '17px',
                        fontFamily: 'Roboto400',
                        display: 'flex',
                        justifyContent: 'space-between',
                        paddingLeft: '20px',
                      }}
                    >
                      <div>{t('life.policyOptions.dividendOptionsCashPaymentMethodCheque')}</div>
                    </div>
                  }
                  className="error-align"
                  name="paymentOptionsCashPaymentMethodCheque"
                >
                  {/* {' '} */}
                  <Select
                    onChange={paymentCashChequeChange}
                    popupClassName="slectop2"
                    placeholder={t('life.policyOptions.dividendOptionsCashPaymentMethodCheque')}
                    // disabled={ArrangeInformation?.paymentModeDisable}
                    style={{
                      fontSize: '20px',
                      fontFamily: 'Roboto400',
                      fontWeight: 'normal',
                      // marginBottom: '15px',
                      padding: '4px 0',
                      paddingLeft: '20px',
                    }}
                    disabled={props.chequeList.length == 1}
                  >
                    {props.chequeList &&
                      props.chequeList.map((item) => (
                        <Select.Option key={item.label} value={item.value}>
                          {i18n.language == 'en' ? item.label : item.labelTc}
                        </Select.Option>
                      ))}
                  </Select>
                </BoldLabelFormItem>

                {formState.paymentOptionsCashPaymentMethodCheque === 'HKD' &&
                  !(props.chequeList.length == 1 && props.chequeList[0].value.toLowerCase() == 'hkd') && (
                    <div
                      style={{
                        fontSize: '17px',
                        fontFamily: 'Roboto400',
                        color: '#6f7072',
                        width: '100%',
                        marginBottom: '24px',
                        paddingLeft: '20px',
                      }}
                    >
                      <div>
                        <span>{t('life.policyOptions.HKDdesscription')}</span>
                      </div>
                    </div>
                  )}
              </Col>
            )}
            {formState.paymentMethodCode == 'DC' && formState.paymentOptionsCode == 'CASHPAYS' && (
              <Row
                justify="center"
                gutter={[16, { xs: 8, sm: 8, lg: 24 }]}
                style={{ rowGap: 0 }}
                className="ChangePaymentContactCard"
              >
                <Col
                  xs={24}
                  md={24}
                  style={{ borderBottom: '1px solid #CCC', marginBottom: '24px', paddingTop: '24px' }}
                >
                  <BoldLabelFormItem
                    rules={[{ required: true, message: t('common.error.requiredField') }]}
                    required
                    label={
                      <span
                        style={{
                          color: '#6f7072',
                          fontWeight: 'normal',
                          fontSize: '17px',
                          fontFamily: 'Roboto400',
                          paddingLeft: '20px',
                        }}
                      >
                        {t('life.policyOptions.paymentOptionsCashPaymentMethodBankCode')}
                      </span>
                    }
                    name="paymentOptionsCashPaymentMethodBankCode"
                    className="error-align"
                  >
                    <Select
                      onChange={paymentBankCode}
                      popupClassName="slectop2"
                      placeholder={t('life.MakeRequest.payment.BankCodeholder')}
                      style={{
                        fontSize: '20px',
                        fontFamily: 'Roboto400',
                        fontWeight: 'normal',
                        paddingLeft: '20px',
                      }}
                      showSearch
                      filterOption={(input, bank) => (bank?.key ?? '').toLowerCase().includes(input.toLowerCase())}
                    >
                      {props.myBankList &&
                        props.myBankList.map((item) => (
                          <Select.Option key={item.label} value={item.value}>
                            {item.label}
                          </Select.Option>
                        ))}
                    </Select>
                  </BoldLabelFormItem>
                </Col>
                <Col xs={24} md={24} style={{ borderBottom: '1px solid #CCC', marginBottom: '24px' }}>
                  <BoldLabelFormItem
                    required
                    rules={[
                      { required: true, message: t('common.error.requiredField') },
                      { pattern: /^\d{3}$/, message: t('life.MakeRequest.payment.InvalidBranchNumber') },
                    ]}
                    label={
                      <span
                        style={{
                          color: '#6f7072',
                          fontWeight: 'normal',
                          fontSize: '17px',
                          fontFamily: 'Roboto400',
                          paddingLeft: '20px',
                        }}
                      >
                        {t('life.MakeRequest.payment.BranchNumber')}
                      </span>
                    }
                    className="error-align"
                    name="paymentOptionsCashPaymentMethodBranchNo"
                  >
                    <Input
                      size="middle"
                      placeholder={t('life.MakeRequest.payment.BranchNumber')}
                      style={{
                        // color: "white",
                        // backgroundColor: 'transparent',
                        fontSize: '20px',
                        fontFamily: 'Roboto400',
                        padding: '0 10px',
                        marginLeft: '20px',
                        width: 'calc(100% - 20px)', // 通过计算宽度来减少20px
                      }}
                    />
                  </BoldLabelFormItem>
                </Col>
                <Col xs={24} md={24} style={{ borderBottom: '1px solid #CCC', marginBottom: '24px' }}>
                  <BoldLabelFormItem
                    rules={[
                      { required: true, message: t('common.error.requiredField') },
                      {
                        // /^\d{1,9}$/
                        pattern: /^\d{1,9}$/,
                        message: t('life.MakeRequest.payment.InvalidBankAccountNumber'),
                      },
                    ]}
                    required
                    label={
                      <span
                        style={{
                          color: '#6f7072',
                          fontWeight: 'normal',
                          fontSize: '17px',
                          fontFamily: 'Roboto400',
                          paddingLeft: '20px',
                        }}
                      >
                        {t('life.MakeRequest.payment.BankAccountNumber')}
                      </span>
                    }
                    name="paymentOptionsCashPaymentMethodAccountNo"
                    className="error-align"
                  >
                    <Input
                      size="middle"
                      onChange={branchNumberChange2}
                      placeholder={t('life.MakeRequest.payment.BankAccountNumber')}
                      style={{
                        // color: "white",
                        // backgroundColor: 'transparent',
                        fontSize: '20px',
                        fontFamily: 'Roboto400',
                        padding: '4px 10px',
                        marginLeft: '20px',
                        width: 'calc(100% - 20px)', // 通过计算宽度来减少20px
                      }}
                      // onBlur={bankNoBlur}
                      // onFocus={() => {
                      //   form.setFieldValue('paymentOptionsCashPaymentMethodAccountNo', originValue2);
                      // }}
                      // suffix={
                      //   showCardMask ? (
                      //     <img src={Visibility} onClick={(e) => changeCardMask2(e)} />
                      //   ) : (
                      //     <img src={VisibilityOff} onClick={(e) => changeCardMask2(e)} />
                      //   )
                      // }
                    />
                  </BoldLabelFormItem>
                  {formState.paymentMethodCode == 'DC' && formState.paymentOptionsCode == 'CASHPAYS' && (
                    <div
                      style={{
                        fontSize: '17px',
                        fontFamily: 'Roboto400',
                        color: '#C21B17',
                        width: '100%',
                        marginBottom: '24px',
                        paddingLeft: '20px',
                      }}
                    >
                      <div>
                        <span>{t('life.policyOptions.provideProof')}</span>
                      </div>
                    </div>
                  )}
                </Col>
                {/* <Col xs={24} md={24} style={{ borderBottom: '1px solid #CCC', marginBottom: '10px' }}>
                <div
                  style={{
                    fontSize: '17px',
                    fontFamily: 'Roboto400',
                    color: '#6F7072',
                    width: '100%',
                    marginBottom: '25px',
                  }}
                >
                  <div>
                    <span>{t('life.MakeRequest.payment.policyholderAccount')}</span>
                  </div>
                </div>
              </Col> */}
                <Col xs={24} md={24}>
                  <BoldLabelFormItem
                    rules={[{ required: true, message: t('common.error.requiredField') }]}
                    required
                    label={
                      <span
                        style={{
                          color: '#6f7072',
                          fontWeight: 'normal',
                          fontSize: '17px',
                          fontFamily: 'Roboto400',
                          paddingLeft: '20px',
                        }}
                      >
                        {t('life.MakeRequest.payment.AccountHolderName')}
                      </span>
                    }
                    className="error-align"
                    name="paymentOptionsCashPaymentMethodHolderName"
                  >
                    <Input
                      size="middle"
                      placeholder={t('life.MakeRequest.payment.AccountHolderName')}
                      style={{
                        // color: "white",
                        // backgroundColor: 'transparent',
                        fontSize: '20px',
                        fontFamily: 'Roboto400',
                        padding: '4px 10px',
                        marginLeft: '20px',
                        width: 'calc(100% - 20px)', // 通过计算宽度来减少20px
                      }}
                    />
                  </BoldLabelFormItem>
                </Col>
              </Row>
            )}
          </div>
        )}
        {/* =================================== */}
        <Col xs={24} md={24}>
          {/* <BoldLabelFormItem
            style={{
              fontSize: '17px',
              fontFamily: 'Roboto400',
              color: '#6F7072',
              borderBottom: '1px solid #CCCCCC',
              width: '100%',
              // paddingBottom: '20px',
            }}
          > */}
          <div
            style={{
              fontSize: '17px',
              fontFamily: 'Roboto400',
              color: '#6F7072',
              borderBottom: '1px solid #CCCCCC',
              width: '100%',
              paddingTop: '10px',
              paddingBottom: '10px',
            }}
          >
            <span>{t('life.MakeRequest.contact.terms')}</span>
          </div>
          {/* </BoldLabelFormItem> */}
          <div style={{ fontSize: '17px', fontFamily: 'Roboto400', paddingTop: '10px', color: '#20252b' }}>
            <span>{t('life.MakeRequest.contact.termstittle')}</span>
          </div>
        </Col>
        <Col xs={24} md={24}>
          <AgreementCard />
        </Col>
        <div
          style={{
            fontSize: '17px',
            fontFamily: 'Roboto400',
            paddingLeft: '2px',
            paddingTop: '15px',
            color: '#20252b',
          }}
        >
          <span>{t('life.MakeRequest.contact.accepttext2')}</span>
        </div>
        {/* <Col xs={24} md={24}>
          <AgreementCard />
        </Col> */}
        {/* <div
          style={{
            fontSize: '17px',
            fontFamily: 'Roboto400',
            paddingLeft: '2px',
            paddingTop: '15px',
            color: '#20252b',
          }}
        >
          <span>{t('life.MakeRequest.contact.accepttext')}</span>
        </div> */}
        {/* <Col xs={24} md={24}>
          {showcard == 'V' && (
            <div>
              <div
                style={{
                  fontSize: '17px',
                  fontFamily: 'Roboto400',
                  paddingTop: '15px',
                  color: '#20252b',
                  paddingLeft: '2px',
                }}
              >
                <div>{t('life.policyOptions.creditcardonly1')}</div>
              </div>
              <div
                style={{
                  fontSize: '17px',
                  fontFamily: 'Roboto400',
                  paddingTop: '15px',
                  color: '#20252b',
                  paddingLeft: '2px',
                }}
              >
                <div>{t('life.policyOptions.creditcardonly2')}</div>
              </div>
            </div>
          )} */}
        {/* {showcard == 'D' && (
            <div>
              <div
                style={{
                  fontSize: '17px',
                  fontFamily: 'Roboto400',
                  paddingTop: '15px',
                  color: '#20252b',
                  paddingLeft: '2px',
                }}
              >
                <div>{t('life.policyOptions.bankAccount1')}</div>
              </div>
              <div
                style={{
                  fontSize: '17px',
                  fontFamily: 'Roboto400',
                  paddingTop: '15px',
                  color: '#20252b',
                  paddingLeft: '2px',
                }}
              >
                <div>{t('life.policyOptions.bankAccount2')}</div>
                <div>{t('life.policyOptions.bankAccount21')}</div>
                <div>{t('life.policyOptions.bankAccount22')}</div>
                <div>{t('life.policyOptions.bankAccount23')}</div>
                <div>{t('life.policyOptions.bankAccount24')}</div>
                <div>{t('life.policyOptions.bankAccount25')}</div>
              </div>
            </div>
          )}
        </Col> */}
      </Row>
    </Row>
  );
});
ChangePolicyOptionsCard.displayName = 'ChangePolicyOptionsCard';
